import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: function () {
      return import('../views/Home.vue')
    }
  },
  {
    path: '/regulation',
    name: 'RegulationShow',
    component: function () {
      return import('../views/Regulation/Show.vue')
    }
  },
  {
    path: '/privace-policy',
    name: 'PrivacePolicyShow',
    component: function () {
      return import('../views/PrivacePolicy/Show.vue')
    }
  },
  {
    path: '/contact',
    name: 'ContactShow',
    component: function () {
      return import('../views/Contact/Show.vue')
    }
  },
  {
    path: '/articles',
    name: 'ArticleList',
    component: function () {
      return import('../views/Article/List.vue')
    }
  },
  {
    path: '/article/show/:id',
    name: 'ArticleShow',
    props: true,
    component: function () {
      return import('../views/Article/Show.vue')
    }
  },
  {
    path: '/events',
    name: 'EventList',
    component: function () {
      return import('../views/Event/List.vue')
    }
  },
  {
    path: '/event/show/:id',
    name: 'EventShow',
    props: true,
    component: function () {
      return import('../views/Event/Show.vue')
    }
  },
  {
    path: '/event/new',
    name: 'EventNew',
    props: true,
    component: function () {
      return import('../views/Event/New.vue')
    }
  },
  {
    path: '/informator',
    name: 'InformatorList',
    component: function () {
      return import('../views/Informator/List.vue')
    }
  },
  {
    path: '/informator/show/:id',
    name: 'InformatorShow',
    props: true,
    component: function () {
      return import('../views/Informator/Show.vue')
    }
  },
  {
    path: '/map',
    name: 'MyMapShow',
    component: function () {
      return import('../views/MyMap/Show.vue')
    }
  },
  {
    path: '/galleries',
    name: 'GalleryList',
    component: function () {
      return import('../views/Gallery/List.vue')
    }
  },
  {
    path: '/gallery/show/:id',
    name: 'GalleryShow',
    props: true,
    component: function () {
      return import('../views/Gallery/Show.vue')
    }
  },
  {
    path: '/multimedia',
    name: 'MultimediaList',
    component: function () {
      return import('../views/Multimedia/List.vue')
    }
  },
  {
    path: '/multimedia/show/:id',
    name: 'MultimediaShow',
    props: true,
    component: function () {
      return import('../views/Multimedia/Show.vue')
    }
  },
  {
    path: '/search/:search_text',
    name: 'SearchList',
    props: true,
    component: function () {
      return import('../views/Search/List.vue')
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
